import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className='footer-body'>
      <p>© Cambridge OCR {currentYear}</p>
    </div>
  );
};

export default Footer;
